import { connect } from 'react-redux';
import chargesActions from '_store/_actions/charges';
import ChargesSummary from './ChargesSummary';

const mapStateToProps = state => {
  return {
    data: state.companyCharges.chargesSummary,
    loading: state.companyCharges.summaryLoading,
    error: state.companyCharges.summaryError,
  };
};

const mapDispatchToProps = {
  onFetchChargesSummary: chargesActions.fetchChargesSummary,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChargesSummary);
